import React, { useMemo, useState } from "react";
import { ProductDetailsModal } from "../../../../../../interfaces/ProductObject";
import { mediaRecordsFromProduct } from "../../../../../../services/helpers/ProductImageHelper";
// Generic MediaRecord renderers, shared with the business gallery. They only
// depend on the MediaRecord contract (interfaces/MediaObject) — if a third
// consumer appears, consider moving them to components/shared/media.
import MediaTile from "../../../../Business/BusinessTabs/tabs/gallery/MediaTile";
import MediaViewer from "../../../../Business/BusinessTabs/tabs/gallery/MediaViewer";
import "./styles/ProductMediaSection.css";

interface ProductMediaSectionProps {
  product: ProductDetailsModal;
}

/**
 * DOCUMENT attachments (PDFs) from `productMediaResources`, shown as a tile
 * strip below the gallery. Images and videos render inline in GallerySection
 * (payload order); PDFs aren't swipeable visual media, so they live here.
 * Renders nothing when the product has no documents.
 */
const ProductMediaSection: React.FC<ProductMediaSectionProps> = ({ product }) => {
  const extraMedia = useMemo(
    () =>
      mediaRecordsFromProduct(product).filter((record) =>
        record.mediaType.startsWith("application/")
      ),
    [product]
  );
  const [viewerIndex, setViewerIndex] = useState<number | null>(null);

  if (extraMedia.length === 0) return null;

  return (
    <section className="pdv2-media">
      <h3 className="pdv2-media__title">Documents</h3>
      <div className="pdv2-media__grid">
        {extraMedia.map((record, index) => (
          <MediaTile
            key={record.objectPath || index}
            record={record}
            label={`Media item ${index + 1}`}
            onOpen={() => setViewerIndex(index)}
          />
        ))}
      </div>

      {viewerIndex !== null && (
        <MediaViewer
          items={extraMedia}
          initialIndex={viewerIndex}
          onClose={() => setViewerIndex(null)}
        />
      )}
    </section>
  );
};

export default ProductMediaSection;
